import axios from 'axios';

const baseURL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 15000,
});

// Surface FastAPI 422 detail arrays as readable strings.
// TF-2 Phase 7: `case_closed` returns a friendly toast pointing users to the
// re-open path in the Sufficiency tab.
const FRIENDLY_DETAILS = {
  case_closed: 'Case is closed — re-open it from the Sufficiency tab to make changes.',
};

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || 'Something went wrong';
  if (typeof detail === 'string') {
    return FRIENDLY_DETAILS[detail] || detail;
  }
  // Async Report Pipeline P2 (Batch 3) — localized structured errors
  // ({code, message_en, message_es}) from generation guards / retry.
  if (typeof detail.message_en === 'string' || typeof detail.message_es === 'string') {
    let lang = '';
    try { lang = localStorage.getItem('i18nextLng') || ''; } catch { /* noop */ }
    return lang.startsWith('en')
      ? (detail.message_en || detail.message_es)
      : (detail.message_es || detail.message_en);
  }
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  }
  if (typeof detail.msg === 'string') return detail.msg;
  if (typeof detail.message === 'string') {
    const extra = Array.isArray(detail.errors)
      ? detail.errors.filter((x) => typeof x === 'string').slice(0, 5).join(' ')
      : '';
    return extra ? `${detail.message} ${extra}` : detail.message;
  }
  try { return JSON.stringify(detail); } catch { return 'Request failed'; }
}
